import { render, staticRenderFns } from "./riskTestDc.vue?vue&type=template&id=eedbd176&scoped=true"
import script from "./riskTestDc.vue?vue&type=script&lang=js"
export * from "./riskTestDc.vue?vue&type=script&lang=js"
import style0 from "./riskTestDc.vue?vue&type=style&index=0&id=eedbd176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eedbd176",
  null
  
)

export default component.exports